import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PropAIApi } from "@core/apis/PropAI";
import { getPropAIOrganizationListQueryOptions } from "@core/apis/PropAI/queries";

export const Route = createFileRoute("/$organizationId")({
  component: RouteComponent,
  beforeLoad: async ({ context: { queryClient, apis }, params }) => {
    const { organizationId } = params;

    // Wait for API to be initialized
    if (!apis?.propAiApi) {
      return {
        organization: undefined,
      };
    }

    const orgs = await queryClient.ensureQueryData(
      getPropAIOrganizationListQueryOptions(apis.propAiApi as PropAIApi)
    );
    return {
      organization: orgs?.find((org) => org.uid === organizationId),
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
